import React, { useState } from 'react';
import './Downloads.css';

const resources = [
  {
    id: 1,
    title: 'Pack de 50 Prompts ChatGPT',
    description: 'Les meilleurs prompts pour productivité, rédaction, analyse et créativité',
    category: 'prompts',
    icon: '💬',
    format: 'PDF',
    size: '2.4 MB',
    content: `# Pack de 50 Prompts ChatGPT

## Productivité (10 prompts)

1. **Résumé de document**
"Résume ce document en 5 points clés, en mettant en avant les informations les plus importantes pour [type de lecteur]."

2. **Générateur d'emails professionnels**
"Rédige un email professionnel pour [situation]. Ton : [formel/décontracté]. Objectif : [but de l'email]."

3. **To-do list intelligente**
"Transforme ces tâches en une liste organisée par priorité avec des estimations de temps : [liste de tâches]"

4. **Compte-rendu de réunion**
"Crée un compte-rendu structuré à partir de ces notes de réunion : [notes]. Inclus les décisions prises et les actions à suivre."

5. **Planification de projet**
"Crée un plan de projet pour [objectif] avec des jalons, des deadlines et des responsabilités pour une équipe de [X] personnes."

## Rédaction (10 prompts)

6. **Article de blog**
"Écris un article de blog de [X] mots sur [sujet]. Public cible : [audience]. Style : [informatif/engageant/expert]."

7. **Post LinkedIn**
"Crée un post LinkedIn viral sur [sujet]. Commence par un hook accrocheur. Utilise des emojis modérément. Termine par une question engageante."

8. **Script vidéo**
"Écris un script de [durée] pour une vidéo YouTube sur [sujet]. Structure : hook (10s), intro (30s), contenu principal, CTA."

9. **Newsletter**
"Rédige une newsletter engageante sur [sujet] avec : un titre accrocheur, 3 sections principales, et un CTA clair."

10. **Description produit**
"Crée une description de produit persuasive pour [produit]. Met en avant les bénéfices, pas les caractéristiques. Ton : [ton souhaité]."

## Analyse (10 prompts)

11. **Analyse SWOT**
"Réalise une analyse SWOT complète pour [entreprise/projet]. Sois spécifique et actionnable."

12. **Étude de marché**
"Analyse le marché de [secteur] : tendances, concurrents principaux, opportunités et menaces."

13. **Feedback constructif**
"Analyse ce [texte/code/design] et donne un feedback constructif avec des suggestions d'amélioration concrètes."

14. **Comparaison de solutions**
"Compare ces [X] solutions : [liste]. Critères : prix, fonctionnalités, facilité d'utilisation, support. Recommandation finale."

15. **Analyse de données**
"Analyse ces données : [données]. Identifie les tendances, anomalies et insights actionnables."

## Créativité (10 prompts)

16. **Brainstorming d'idées**
"Génère 20 idées créatives pour [objectif]. Inclus des idées conventionnelles ET des idées audacieuses."

17. **Noms de marque**
"Propose 15 noms de marque pour [type d'entreprise]. Critères : mémorable, disponible en .com, évocateur de [valeurs]."

18. **Slogans**
"Crée 10 slogans percutants pour [marque/produit]. Style : [inspirant/humoristique/professionnel]."

19. **Concepts de contenu**
"Propose un calendrier de contenu d'1 mois pour [plateforme] sur le thème [thème]. 3 posts/semaine."

20. **Storytelling**
"Crée une histoire captivante pour illustrer [message/valeur] de ma marque. Format : [court/long]."

## Business (10 prompts)

21. **Pitch elevator**
"Crée un pitch de 30 secondes pour [startup/projet]. Problème → Solution → Différenciation → Ask."

22. **Business Model Canvas**
"Remplis un Business Model Canvas pour [idée business]. Sois précis sur chaque bloc."

23. **Pricing strategy**
"Propose une stratégie de pricing pour [produit/service]. Analyse la valeur perçue et le positionnement."

24. **Objections commerciales**
"Liste les 10 objections les plus courantes pour [produit] et propose des réponses persuasives."

25. **Partenariats**
"Identifie 10 partenaires potentiels pour [entreprise] et propose une approche pour chacun."

## Technique (10 prompts)

26. **Debug de code**
"J'ai cette erreur : [erreur]. Voici mon code : [code]. Trouve le problème et propose une solution."

27. **Optimisation de code**
"Optimise ce code pour [performance/lisibilité/maintenabilité] : [code]"

28. **Architecture technique**
"Propose une architecture technique pour [projet] avec : stack recommandée, schéma, et justifications."

29. **Documentation**
"Crée une documentation technique pour [fonction/API]. Inclus exemples et cas d'usage."

30. **Tests unitaires**
"Écris des tests unitaires complets pour cette fonction : [code]. Couvre les cas limites."

## Apprentissage (10 prompts)

31. **Explication simplifiée**
"Explique [concept complexe] comme si j'avais 10 ans. Utilise des analogies du quotidien."

32. **Plan d'apprentissage**
"Crée un plan d'apprentissage de [X] semaines pour maîtriser [compétence]. De débutant à avancé."

33. **Quiz de révision**
"Crée un quiz de 10 questions sur [sujet] pour tester ma compréhension. Niveaux variés."

34. **Résumé de livre**
"Résume les idées clés du livre [titre] en 10 points actionnables."

35. **Méthode Feynman**
"Utilise la méthode Feynman pour m'expliquer [concept]. Identifie mes lacunes potentielles."

## Communication (10 prompts)

36. **Négociation**
"Prépare-moi à négocier [situation]. Arguments, contre-arguments, BATNA, et stratégie."

37. **Présentation**
"Crée un plan de présentation de [X] minutes sur [sujet]. Structure : attention, intérêt, désir, action."

38. **Feedback délicat**
"Aide-moi à formuler un feedback délicat sur [situation] de manière constructive et bienveillante."

39. **Réponse à un client mécontent**
"Rédige une réponse empathique à ce client mécontent : [message]. Objectif : résoudre et fidéliser."

40. **Demande de promotion**
"Aide-moi à préparer ma demande de promotion/augmentation. Arguments, timing, et approche."

## Personal Branding (5 prompts)

41. **Bio professionnelle**
"Écris ma bio professionnelle pour [plateforme]. Background : [infos]. Objectif : [objectif]."

42. **Positionnement d'expert**
"Aide-moi à me positionner comme expert en [domaine]. Stratégie de contenu et différenciation."

43. **Portfolio review**
"Analyse mon portfolio et suggère des améliorations pour [objectif] : [lien ou description]."

44. **Personal pitch**
"Crée mon pitch personnel pour [contexte : networking/entretien/conférence]."

45. **Thought leadership**
"Propose 5 angles originaux sur [sujet de mon expertise] pour me différencier."

## Bonus (5 prompts)

46. **Méga-prompt**
"Tu es [rôle expert]. Ta mission : [objectif]. Contraintes : [contraintes]. Format attendu : [format]. Commence par me poser 3 questions pour mieux comprendre mon besoin."

47. **Reverse engineering**
"Analyse ce [contenu viral/succès] et explique pourquoi ça marche. Leçons à appliquer."

48. **Simulation**
"Simule une conversation avec [type de personne : investisseur/client/recruteur]. Je vais m'entraîner."

49. **Critique constructive**
"Sois mon avocat du diable sur [idée/projet]. Challenge chaque aspect sans complaisance."

50. **Vision long terme**
"Aide-moi à définir ma vision à 5 ans pour [domaine]. Puis crée un plan d'action rétro-planifié."

---

💡 **Conseil d'utilisation** : Personnalisez toujours les [variables] et itérez sur les réponses pour affiner le résultat.

© F12IA™ - Formation IA Complète`
  },
  {
    id: 2,
    title: 'Template Brief Projet',
    description: 'Le template parfait pour briefer Claude Code sur vos projets',
    category: 'templates',
    icon: '📋',
    format: 'TXT',
    size: '45 KB',
    content: `# TEMPLATE BRIEF PROJET - F12IA™

## INFORMATIONS GÉNÉRALES
- **Nom du projet** : [Nom]
- **Type** : [Web App / Mobile App / Site vitrine / SaaS / Outil interne / Autre]
- **Date de début** : [Date]
- **Deadline souhaitée** : [Date]

---

## 1. DESCRIPTION DU PROJET

### Le problème
[Décrivez le problème que vous résolvez en 2-3 phrases]

### La solution
[Décrivez votre solution en 2-3 phrases]

### Proposition de valeur
[Pourquoi les gens utiliseraient votre solution plutôt qu'une autre ?]

---

## 2. UTILISATEUR CIBLE

### Persona principal
- **Qui** : [Ex: Entrepreneurs solo, 25-45 ans]
- **Problème principal** : [Leur plus grande frustration]
- **Objectif** : [Ce qu'ils veulent accomplir]
- **Niveau technique** : [Débutant / Intermédiaire / Expert]

### Contexte d'utilisation
- **Quand** : [À quel moment utilisent-ils l'outil ?]
- **Où** : [Desktop / Mobile / Les deux]
- **Fréquence** : [Quotidien / Hebdomadaire / Ponctuel]

---

## 3. FONCTIONNALITÉS

### MVP (Version 1 - Indispensable)
1. [Fonctionnalité 1 - Description détaillée]
2. [Fonctionnalité 2 - Description détaillée]
3. [Fonctionnalité 3 - Description détaillée]

### Version 2 (Nice to have)
1. [Fonctionnalité 4]
2. [Fonctionnalité 5]

### Futur (Vision long terme)
1. [Fonctionnalité future 1]
2. [Fonctionnalité future 2]

---

## 4. PARCOURS UTILISATEUR

### Parcours principal
1. L'utilisateur arrive sur [page]
2. Il voit [élément]
3. Il clique sur [bouton/lien]
4. Il [action]
5. Résultat : [ce qu'il obtient]

### Parcours secondaire (si applicable)
[Décrire un autre parcours important]

---

## 5. DESIGN & UX

### Style général
- [ ] Moderne / Minimaliste
- [ ] Corporate / Professionnel
- [ ] Fun / Coloré
- [ ] Dark mode
- [ ] Autre : ___

### Palette de couleurs
- Couleur principale : [#hexcode ou description]
- Couleur secondaire : [#hexcode ou description]
- Couleur d'accent : [#hexcode ou description]

### Références visuelles
[Lister 2-3 sites/apps qui ont un style similaire à ce que vous voulez]
1. [URL ou nom]
2. [URL ou nom]

### Logo
- [ ] J'ai déjà un logo
- [ ] Je veux un logo simple texte
- [ ] Pas de logo pour l'instant

---

## 6. TECHNIQUE

### Authentification
- [ ] Pas d'authentification nécessaire
- [ ] Email/Mot de passe
- [ ] Google Sign-in
- [ ] Autre : ___

### Base de données
- [ ] Pas de données à stocker
- [ ] Données utilisateur simples (profil, préférences)
- [ ] Données métier complexes (décrire : ___)

### Intégrations souhaitées
- [ ] Paiement (Stripe)
- [ ] Envoi d'emails (SendGrid, Resend)
- [ ] API externe : ___
- [ ] Autre : ___

### Hébergement prévu
- [ ] Vercel (recommandé pour React)
- [ ] Netlify
- [ ] Autre : ___
- [ ] Je ne sais pas (Claude Code me conseillera)

---

## 7. CONTENU

### Textes
- [ ] Je fournirai tous les textes
- [ ] J'ai besoin d'aide pour les textes
- [ ] Utiliser du Lorem Ipsum pour l'instant

### Images
- [ ] Je fournirai les images
- [ ] Utiliser des images stock (Unsplash)
- [ ] Pas d'images nécessaires

---

## 8. CONTRAINTES & PRIORITÉS

### Budget
- [ ] Gratuit (outils et hébergement gratuits uniquement)
- [ ] Petit budget (<50€/mois)
- [ ] Budget flexible

### Priorité #1
[Quelle est LA chose la plus importante pour ce projet ?]

### Ce que je veux éviter
[Y a-t-il des choses que vous ne voulez absolument pas ?]

---

## 9. INFORMATIONS COMPLÉMENTAIRES

### Existant
- [ ] C'est un nouveau projet from scratch
- [ ] C'est une refonte (lien vers l'existant : ___)
- [ ] C'est un ajout à un projet existant (décrire : ___)

### Domaine
- [ ] J'ai déjà un domaine : ___
- [ ] Je dois en acheter un
- [ ] Pas de domaine personnalisé nécessaire

### Notes additionnelles
[Tout ce qui n'est pas couvert ci-dessus]

---

## CHECKLIST AVANT DE COMMENCER

- [ ] J'ai défini clairement le problème que je résous
- [ ] J'ai listé les 3-5 fonctionnalités essentielles du MVP
- [ ] J'ai décrit le parcours utilisateur principal
- [ ] J'ai une idée du style visuel souhaité
- [ ] J'ai identifié les contraintes techniques (auth, BDD, etc.)

---

💡 **Conseil F12IA™** : Plus votre brief est détaillé, meilleur sera le résultat. N'hésitez pas à ajouter des captures d'écran, des schémas ou des références visuelles.

© F12IA™ - Formation IA Complète`
  },
  {
    id: 3,
    title: 'Checklist Lancement Projet',
    description: 'Tout ce qu\'il faut vérifier avant de mettre en ligne votre projet',
    category: 'templates',
    icon: '✅',
    format: 'PDF',
    size: '1.8 MB',
    content: `# CHECKLIST LANCEMENT PROJET - F12IA™

## AVANT LE DÉVELOPPEMENT

### Définition du projet
- [ ] Problème clairement défini
- [ ] Solution décrite en une phrase
- [ ] Public cible identifié
- [ ] 3-5 fonctionnalités MVP listées
- [ ] Parcours utilisateur principal documenté

### Préparation
- [ ] Compte GitHub créé
- [ ] Node.js installé (v18+)
- [ ] VS Code ou éditeur de code installé
- [ ] Compte Vercel/Netlify créé (pour l'hébergement)

---

## PENDANT LE DÉVELOPPEMENT

### Structure du code
- [ ] Projet initialisé avec Create React App ou Vite
- [ ] Dossiers organisés (components, pages, utils, etc.)
- [ ] Variables d'environnement configurées (.env)
- [ ] .gitignore correctement configuré

### Fonctionnalités
- [ ] Toutes les fonctionnalités MVP implémentées
- [ ] Navigation entre les pages fonctionnelle
- [ ] Formulaires avec validation
- [ ] Gestion des erreurs (messages clairs pour l'utilisateur)
- [ ] États de chargement (loading states)

### Responsive Design
- [ ] Mobile (320px - 480px)
- [ ] Tablette (481px - 768px)
- [ ] Desktop (769px - 1024px)
- [ ] Grand écran (1025px+)

### Accessibilité (a11y)
- [ ] Contraste suffisant (texte lisible)
- [ ] Images avec attribut alt
- [ ] Navigation au clavier possible
- [ ] Labels sur les champs de formulaire

---

## AVANT LA MISE EN LIGNE

### Tests fonctionnels
- [ ] Parcours utilisateur principal testé de A à Z
- [ ] Tous les boutons cliquables fonctionnent
- [ ] Tous les liens mènent quelque part
- [ ] Formulaires soumis correctement
- [ ] Messages d'erreur affichés quand nécessaire

### Tests techniques
- [ ] Pas d'erreurs dans la console (F12)
- [ ] Pas de liens cassés (404)
- [ ] Images chargées correctement
- [ ] Temps de chargement acceptable (<3s)

### Sécurité
- [ ] Pas de clés API exposées dans le code
- [ ] Variables sensibles dans .env
- [ ] HTTPS activé
- [ ] Validation côté serveur (si applicable)

### SEO & Performance
- [ ] Balises meta title et description
- [ ] Favicon configuré
- [ ] Open Graph tags (pour les partages sociaux)
- [ ] Images optimisées (compressées)
- [ ] Pas de fichiers inutiles

---

## DÉPLOIEMENT

### Préparation
- [ ] Code poussé sur GitHub
- [ ] Build de production testé en local (npm run build)
- [ ] Variables d'environnement configurées sur l'hébergeur

### Vercel (recommandé)
- [ ] Projet importé depuis GitHub
- [ ] Build settings vérifiés
- [ ] Variables d'environnement ajoutées
- [ ] Deploy réussi

### Post-déploiement
- [ ] Site accessible via l'URL Vercel
- [ ] Toutes les fonctionnalités testées en production
- [ ] Pas d'erreurs dans les logs Vercel

---

## DOMAINE PERSONNALISÉ (optionnel)

### Achat du domaine
- [ ] Domaine disponible vérifié
- [ ] Domaine acheté (Namecheap, Google Domains, etc.)

### Configuration DNS
- [ ] Domaine ajouté dans Vercel
- [ ] DNS configurés chez le registrar
- [ ] Propagation DNS terminée (peut prendre 24-48h)
- [ ] HTTPS automatique activé

### Vérification finale
- [ ] Site accessible via le domaine personnalisé
- [ ] Redirection www → non-www (ou inverse)
- [ ] HTTPS fonctionnel

---

## POST-LANCEMENT

### Analytics
- [ ] Google Analytics ou Vercel Analytics configuré
- [ ] Événements clés trackés (inscriptions, clics, etc.)

### Monitoring
- [ ] Alertes configurées (si le site tombe)
- [ ] Logs accessibles

### Documentation
- [ ] README à jour
- [ ] Credentials stockés de manière sécurisée
- [ ] Process de déploiement documenté

### Backup
- [ ] Code sur GitHub (= backup)
- [ ] Base de données sauvegardée (si applicable)

---

## CHECKLIST RAPIDE (J-1 avant lancement)

- [ ] Le site fonctionne sur mon téléphone
- [ ] Mon ami/collègue a testé et compris comment ça marche
- [ ] Pas d'erreur quand je rafraîchis la page
- [ ] Les formulaires envoient bien les données
- [ ] J'ai une façon de récupérer les feedbacks utilisateurs

---

💡 **Le secret d'un bon lancement** : Lancez "assez bien" plutôt que "parfait". Vous pourrez toujours améliorer après.

© F12IA™ - Formation IA Complète`
  },
  {
    id: 4,
    title: 'Guide des Automatisations',
    description: 'Templates Zapier/Make prêts à l\'emploi pour automatiser votre business',
    category: 'guides',
    icon: '⚡',
    format: 'PDF',
    size: '3.1 MB',
    content: `# GUIDE DES AUTOMATISATIONS - F12IA™

## INTRODUCTION

Ce guide contient des templates d'automatisations prêts à l'emploi.
Chaque automatisation est décrite avec :
- Le déclencheur (trigger)
- Les actions
- Les outils nécessaires
- Le temps de mise en place estimé

---

## CATÉGORIE 1 : EMAIL MARKETING

### Auto 1 : Welcome Sequence
**Objectif** : Envoyer une série d'emails de bienvenue aux nouveaux inscrits

**Déclencheur** : Nouvelle inscription à la newsletter

**Actions** :
1. Email J+0 : "Bienvenue ! Voici ce qui vous attend"
2. Email J+2 : "Votre premier conseil gratuit"
3. Email J+5 : "Une ressource exclusive pour vous"
4. Email J+7 : "Prêt à passer à l'action ?"

**Outils** : Mailchimp + Zapier (ou ConvertKit natif)
**Temps** : 1-2 heures

---

### Auto 2 : Lead Magnet Delivery
**Objectif** : Envoyer automatiquement un PDF quand quelqu'un remplit un formulaire

**Déclencheur** : Soumission de formulaire (Typeform, Google Forms, etc.)

**Actions** :
1. Récupérer l'email du formulaire
2. Envoyer un email avec le PDF en pièce jointe
3. Ajouter le contact à une liste "Leads"
4. (Optionnel) Notifier sur Slack

**Outils** : Typeform + Zapier + Gmail
**Temps** : 30 minutes

---

## CATÉGORIE 2 : GESTION DE CLIENTS

### Auto 3 : Onboarding Client Automatisé
**Objectif** : Automatiser l'onboarding quand un nouveau client achète

**Déclencheur** : Nouveau paiement Stripe

**Actions** :
1. Créer une fiche client dans Notion/Airtable
2. Envoyer un email de bienvenue personnalisé
3. Créer un dossier Google Drive pour le client
4. Envoyer un lien Calendly pour le kick-off call
5. Notifier l'équipe sur Slack

**Outils** : Stripe + Zapier + Notion + Gmail + Google Drive + Calendly
**Temps** : 2-3 heures

---

### Auto 4 : Suivi de satisfaction
**Objectif** : Collecter des avis clients automatiquement

**Déclencheur** : 7 jours après la livraison (champ date dans Airtable)

**Actions** :
1. Envoyer un email avec lien vers formulaire de satisfaction
2. Si note >= 4/5 : demander un avis Google/Trustpilot
3. Si note < 4/5 : créer une tâche pour appeler le client

**Outils** : Airtable + Zapier + Gmail + Typeform
**Temps** : 1-2 heures

---

## CATÉGORIE 3 : RÉSEAUX SOCIAUX

### Auto 5 : Content Repurposing
**Objectif** : Transformer un article de blog en posts sociaux

**Déclencheur** : Nouvel article publié (RSS du blog)

**Actions** :
1. Extraire le titre et le résumé
2. Créer un post LinkedIn (via ChatGPT API)
3. Créer un thread Twitter (via ChatGPT API)
4. Sauvegarder dans Notion pour review
5. Programmer la publication avec Buffer

**Outils** : RSS + Zapier + OpenAI + Notion + Buffer
**Temps** : 2 heures

---

### Auto 6 : Veille concurrentielle
**Objectif** : Être alerté quand un concurrent publie

**Déclencheur** : Nouveau post détecté (Google Alerts ou RSS)

**Actions** :
1. Enregistrer l'article dans Notion
2. Résumer avec ChatGPT
3. Envoyer une notification Slack à l'équipe marketing

**Outils** : Google Alerts + Zapier + OpenAI + Notion + Slack
**Temps** : 1 heure

---

## CATÉGORIE 4 : PRODUCTIVITÉ PERSONNELLE

### Auto 7 : Daily Digest
**Objectif** : Recevoir un résumé quotidien de vos tâches et événements

**Déclencheur** : Tous les jours à 7h00

**Actions** :
1. Récupérer les événements du jour (Google Calendar)
2. Récupérer les tâches dues (Todoist/Notion)
3. Compiler dans un email formaté
4. Envoyer à vous-même

**Outils** : Zapier Schedule + Google Calendar + Todoist + Gmail
**Temps** : 45 minutes

---

### Auto 8 : Capture de notes vocales
**Objectif** : Transformer des notes vocales en texte organisé

**Déclencheur** : Nouvelle note vocale dans un dossier Dropbox

**Actions** :
1. Transcrire avec Whisper API
2. Résumer et structurer avec ChatGPT
3. Créer une note dans Notion
4. Supprimer le fichier audio original

**Outils** : Dropbox + Zapier + OpenAI (Whisper + GPT) + Notion
**Temps** : 1 heure

---

## CATÉGORIE 5 : VENTES

### Auto 9 : Lead Scoring Automatique
**Objectif** : Noter automatiquement les leads selon leur engagement

**Déclencheur** : Mise à jour d'un lead dans le CRM

**Actions** :
1. Vérifier les critères (secteur, taille entreprise, actions)
2. Calculer un score
3. Si score > seuil : alerter le commercial
4. Si score très élevé : programmer un email personnalisé

**Outils** : HubSpot/Pipedrive + Zapier + Slack
**Temps** : 2 heures

---

### Auto 10 : Proposition commerciale auto-générée
**Objectif** : Générer une première version de proposition

**Déclencheur** : Bouton "Générer proposition" cliqué (formulaire)

**Actions** :
1. Récupérer les infos du prospect
2. Générer la proposition avec ChatGPT (template + personnalisation)
3. Créer un Google Doc avec le contenu
4. Envoyer le lien par email au commercial

**Outils** : Google Forms + Zapier + OpenAI + Google Docs + Gmail
**Temps** : 2-3 heures

---

## TEMPLATES ZAPIER RECOMMANDÉS

### Niveau Débutant
1. "New Typeform response → Add row to Google Sheets"
2. "New Gmail attachment → Save to Google Drive"
3. "New calendar event → Create Slack reminder"

### Niveau Intermédiaire
4. "New Stripe payment → Create Notion page + Send email"
5. "RSS feed → ChatGPT summary → Post to LinkedIn"
6. "New lead in CRM → Score + Route to right team"

### Niveau Avancé
7. "Multi-step client onboarding with conditions"
8. "AI-powered content pipeline"
9. "Full sales automation with webhooks"

---

## BONNES PRATIQUES

### Avant de créer une automatisation
1. Faire le process manuellement 3 fois
2. Identifier les étapes répétitives
3. Vérifier que les outils sont connectables

### Pendant la création
1. Commencer simple, ajouter de la complexité
2. Tester à chaque étape
3. Prévoir les cas d'erreur

### Après la mise en place
1. Monitorer pendant 1 semaine
2. Ajuster selon les résultats
3. Documenter pour l'équipe

---

💡 **Règle d'or** : Si vous faites une tâche plus de 3 fois par semaine et qu'elle prend plus de 5 minutes, automatisez-la.

© F12IA™ - Formation IA Complète`
  },
  {
    id: 5,
    title: 'Cheatsheet Claude Code',
    description: 'Les commandes et bonnes pratiques essentielles pour Claude Code',
    category: 'guides',
    icon: '🤖',
    format: 'PDF',
    size: '890 KB',
    content: `# CHEATSHEET CLAUDE CODE - F12IA™

## DÉMARRAGE RAPIDE

### Installation
\`\`\`bash
npm install -g @anthropic-ai/claude-code
\`\`\`

### Lancement
\`\`\`bash
claude-code
\`\`\`

### Commandes de base
- \`/help\` - Afficher l'aide
- \`/clear\` - Effacer la conversation
- \`/exit\` - Quitter

---

## PROMPTS ESSENTIELS

### Créer un nouveau projet
"Crée un projet [React/Node/Python] pour [description].
Structure professionnelle avec [spécifications]."

### Expliquer du code
"Explique ce code ligne par ligne :
[coller le code]"

### Débugger
"J'ai cette erreur : [erreur]
Code concerné : [code]
Ce que j'ai essayé : [tentatives]
Trouve et corrige le problème."

### Optimiser
"Optimise ce code pour [performance/lisibilité/maintenabilité] :
[code]"

### Ajouter une fonctionnalité
"Dans ce fichier [nom], ajoute [fonctionnalité].
Contraintes : [contraintes]"

---

## STRUCTURE DE PROJET RECOMMANDÉE

### React
\`\`\`
mon-projet/
├── src/
│   ├── components/     # Composants réutilisables
│   ├── pages/          # Pages/Routes
│   ├── contexts/       # Contextes React
│   ├── hooks/          # Hooks personnalisés
│   ├── utils/          # Fonctions utilitaires
│   ├── services/       # Appels API
│   ├── styles/         # CSS/SCSS global
│   └── App.js
├── public/
├── package.json
└── README.md
\`\`\`

### Node.js Backend
\`\`\`
backend/
├── src/
│   ├── routes/         # Routes API
│   ├── controllers/    # Logique métier
│   ├── models/         # Modèles de données
│   ├── middleware/     # Middlewares
│   ├── utils/          # Utilitaires
│   └── index.js
├── config/
├── package.json
└── .env
\`\`\`

---

## FORMULES MAGIQUES

### Pour être plus précis
"Voici le contexte : [contexte]
Je veux exactement : [spécification détaillée]
Format de sortie : [format attendu]
Contraintes : [ce qu'il ne faut PAS faire]"

### Pour itérer efficacement
"C'est bien, mais :
- Change [X] en [Y]
- Ajoute [Z]
- Supprime [W]
Garde tout le reste identique."

### Pour du code production-ready
"Génère du code de qualité production avec :
- Gestion d'erreurs complète
- Validation des inputs
- Types (TypeScript si applicable)
- Commentaires sur les parties complexes
- Tests unitaires"

---

## RACCOURCIS MENTAUX

| Tu veux... | Dis... |
|------------|--------|
| Comprendre | "Explique comme si j'avais 10 ans" |
| Du code propre | "Refactorise pour la lisibilité" |
| Aller vite | "Code minimal qui fonctionne" |
| Être sûr | "Ajoute des tests pour ce code" |
| Debugger | "Trouve tous les bugs potentiels" |
| Documenter | "Ajoute des commentaires JSDoc" |

---

## ERREURS COURANTES À ÉVITER

❌ "Fais-moi un site"
✅ "Crée une page d'accueil React avec : header fixe, hero section avec CTA, 3 features cards, footer. Style moderne, palette bleu/blanc."

❌ "Ça marche pas"
✅ "Erreur : [message exact]. Étapes pour reproduire : [étapes]. Comportement attendu : [attendu]. Comportement actuel : [actuel]."

❌ "Améliore ça"
✅ "Dans cette fonction, optimise la performance en réduisant la complexité de O(n²) à O(n)."

---

## WORKFLOW IDÉAL

### 1. Planification
"Je veux créer [projet].
Propose-moi une structure de dossiers et les étapes de développement."

### 2. Setup
"Initialise le projet avec [stack].
Configure [outils : ESLint, Prettier, etc.]"

### 3. Développement (itératif)
"Crée [composant/feature] avec [spécifications]"
→ Test
→ "Ajuste [détail]"
→ Valide
→ Prochain composant

### 4. Finalisation
"Vérifie tout le code pour :
- Erreurs potentielles
- Problèmes de sécurité
- Performance
- Accessibilité"

### 5. Déploiement
"Guide-moi pour déployer sur [Vercel/Netlify/Railway]"

---

## TIPS AVANCÉS

### Contexte persistant
Commencez chaque session par :
"Contexte du projet : [rappel rapide]
Dernière fois : [où on en était]
Aujourd'hui : [objectif]"

### Multi-fichiers
"Je vais te donner plusieurs fichiers. Attends que je te dise 'GO' avant de répondre.
Fichier 1 : [code]
Fichier 2 : [code]
GO - Maintenant [instruction]"

### Code review
"Fais une code review de ce fichier.
Critères : performance, sécurité, lisibilité, best practices.
Format : liste de suggestions avec priorité (haute/moyenne/basse)"

---

## RESSOURCES

### Documentation
- React : react.dev
- Node.js : nodejs.org/docs
- MDN Web Docs : developer.mozilla.org

### Outils complémentaires
- GitHub Copilot (complétion dans l'IDE)
- Vercel (déploiement)
- Supabase (backend as a service)

---

💡 **Rappel** : Claude Code est un outil. Plus vos instructions sont claires, meilleur est le résultat. Itérez, testez, affinez.

© F12IA™ - Formation IA Complète`
  }
];

const Downloads = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [downloadingId, setDownloadingId] = useState(null);

  const categories = [
    { id: 'all', label: 'Tout', icon: '📦' },
    { id: 'prompts', label: 'Prompts', icon: '💬' },
    { id: 'templates', label: 'Templates', icon: '📋' },
    { id: 'guides', label: 'Guides', icon: '📚' }
  ];

  const filteredResources = selectedCategory === 'all'
    ? resources
    : resources.filter(r => r.category === selectedCategory);

  const handleDownload = (resource) => {
    setDownloadingId(resource.id);

    // Create a blob with the content
    const blob = new Blob([resource.content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    // Create download link
    const link = document.createElement('a');
    link.href = url;
    link.download = `${resource.title.replace(/\s+/g, '_')}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup
    URL.revokeObjectURL(url);

    setTimeout(() => setDownloadingId(null), 1000);
  };

  return (
    <div className="downloads-container">
      <div className="downloads-header">
        <div className="downloads-icon">📥</div>
        <div>
          <h2>Ressources Téléchargeables</h2>
          <p>Templates, prompts et guides prêts à l'emploi</p>
        </div>
      </div>

      <div className="downloads-filters">
        {categories.map(cat => (
          <button
            key={cat.id}
            className={`filter-btn ${selectedCategory === cat.id ? 'active' : ''}`}
            onClick={() => setSelectedCategory(cat.id)}
          >
            <span>{cat.icon}</span>
            <span>{cat.label}</span>
          </button>
        ))}
      </div>

      <div className="downloads-grid">
        {filteredResources.map(resource => (
          <div key={resource.id} className="resource-card">
            <div className="resource-icon">{resource.icon}</div>
            <div className="resource-content">
              <h3>{resource.title}</h3>
              <p>{resource.description}</p>
              <div className="resource-meta">
                <span className="resource-format">{resource.format}</span>
                <span className="resource-size">{resource.size}</span>
              </div>
            </div>
            <button
              className={`download-btn ${downloadingId === resource.id ? 'downloading' : ''}`}
              onClick={() => handleDownload(resource)}
              disabled={downloadingId === resource.id}
            >
              {downloadingId === resource.id ? (
                <>
                  <span className="spinner"></span>
                  Téléchargement...
                </>
              ) : (
                <>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  Télécharger
                </>
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Downloads;
